import { render } from "./SubscribeButton.vue?vue&type=template&id=6970a5c8&scoped=true"
import script from "./SubscribeButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscribeButton.vue?vue&type=script&setup=true&lang=js"

import "./SubscribeButton.vue?vue&type=style&index=0&id=6970a5c8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6970a5c8"],['__file',"src/components/SubscribeButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6970a5c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6970a5c8', __exports__)) {
    api.reload('6970a5c8', __exports__)
  }
  
  module.hot.accept("./SubscribeButton.vue?vue&type=template&id=6970a5c8&scoped=true", () => {
    api.rerender('6970a5c8', render)
  })

}


export default __exports__